import React, { useContext } from 'react';
import { Container } from 'react-bootstrap';
import { Link as GatsbyLink } from 'gatsby';
import { Link as ScrollLink } from 'react-scroll';
import PortfolioContext from '../../context/context';
// import GithubButtons from '../GithubButtons/GithubButtons';

// import { githubButtons } from '../../mock/data';

const Footer = () => {
  const { footer } = useContext(PortfolioContext);
  const { networks } = footer;
  // const { isEnabled } = githubButtons;

  return (
    <footer className="footer navbar-static-bottom">
      <Container>
        <span className="back-to-top">
          <ScrollLink to="hero" smooth duration={1000}>
            <i className="fa fa-angle-up fa-2x" aria-hidden="true" />
          </ScrollLink>
        </span>
        <div className="social-links">
          {networks &&
            networks.map((network) => {
              const { id, name, url } = network;
              return (
                <a
                  key={id}
                  href={url || 'https://github.com/kenRp01/kenRp01.github.io'}
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label={name}
                >
                  <i className={`fa fa-${name || 'refresh'} fa-inverse`} />
                </a>
              );
            })}
        </div>
        <hr />
        <p>
          <a className="text-white" href="https://kenrp01.github.io/kenRp-blog/">
            KenRp Blog
          </a>
        </p>
        <p>
          <GatsbyLink className="text-white" to="/privacy/">
            プライバシーポリシー・運営者情報
          </GatsbyLink>
        </p>
        <p className="footer__text">
          © {new Date().getFullYear()} - Template developed by{' '}
          <a href="https://github.com/kenRp01" target="_blank" rel="noopener noreferrer">
            kenRp01
          </a>
        </p>

        {/* {isEnabled && <GithubButtons />} */}
      </Container>
    </footer>
  );
};

export default Footer;
